import React from "react";
import DashboardView from "./DashboardView";

const DashboardContainer = () => {
  return <DashboardView />;
};

export default DashboardContainer;
